import {GlobalSettings, HiveActionsPopup, HiveActionsPopupElement, TableSettingsCol} from "./styles";
import {MoreIcon} from "shared/ui/icons/moreIcon.tsx";
import {useRef, useState} from "react";
import { Link } from "react-router-dom";
import {archiveHive, unarchiveHive} from "features/hives/helpers/archiveHive.ts";
import {useHivesStore} from "entities/hives";
import Popover from '@atomaro/ui-kit/components/Popover/Popover';


export const HivesSettingsCell = ({id, isDeleted}: {id: string, isDeleted: boolean}) => {
    const colRef = useRef<HTMLDivElement | null>(null);

    const reload = useHivesStore((s) => s.reload);

    const onArchive = async () => {
        try {
            let status = 404;
            if (isDeleted) {
                status = await unarchiveHive(id);
            } else {
                status = await archiveHive(id);
            }
            if (status >= 200 && status < 300) {
                await reload();
            }
        } finally {
            close();
        }
    };

    const [isOpened, setIsOpened] = useState<boolean>(false)

    return (
        <>
            <GlobalSettings/>
            <TableSettingsCol ref={colRef}>
                <Popover
                    isOpened={isOpened}
                    onOpen={() => {
                        setIsOpened(true)
                    }}
                    onClose={() => {
                        setIsOpened(false)
                    }}
                    placement="bottomLeft"
                    className={"settingsPopupTable"}
                    innerChildren={
                        <HiveActionsPopup>
                            <HiveActionsPopupElement>
                                <Link to={`/hive/${id}`}>
                                    Посмотреть
                                </Link>
                            </HiveActionsPopupElement>
                            <HiveActionsPopupElement onClick={onArchive}>
                                {
                                    isDeleted ?
                                        "Вынести из архива"
                                        : "Архивировать"
                                }
                            </HiveActionsPopupElement>
                        </HiveActionsPopup>
                    }
                >
                    <MoreIcon onClick={() => {
                        if (isOpened) setIsOpened(false)
                    }}/>
                </Popover>
            </TableSettingsCol>
        </>
    )
};